import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/toaster";
import { TooltipProvider } from "@/components/ui/tooltip";
import { AuthProvider } from "@/hooks/useAuth";
import Navbar from "@/components/Navbar";
import MinimalFooter from "@/components/MinimalFooter";
import FeedbackWidget from "@/components/FeedbackWidget";
import RouteSeo from "@/components/RouteSeo";

import LandingPage from "@/pages/LandingPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import GrafikenPage from "@/pages/GrafikenPage";
import AgbPage from "./pages/AgbPage";
import ImpressumPage from "@/pages/ImpressumPage";
import DatenschutzPage from "@/pages/DatenschutzPage";
import CheckoutPage from "@/pages/CheckoutPage";
import CheckoutReturnPage from "@/pages/CheckoutReturnPage";
import NotFound from "@/pages/NotFound";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <BrowserRouter>
        <AuthProvider>
          <RouteSeo />
          <Navbar />
          <Routes>
            <Route path="/" element={<LandingPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/anmelden" element={<LoginPage />} />
            <Route path="/passwort-vergessen" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/signup" element={<RegisterPage />} />
            <Route path="/registrieren" element={<RegisterPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/mein-verein" element={<DashboardPage />} />
            <Route path="/grafiken" element={<GrafikenPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/checkout/return" element={<CheckoutReturnPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
            <Route path="/agb" element={<AgbPage />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
          <MinimalFooter />
          <FeedbackWidget />
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
